export default __webpack_public_path__ + "static/media/success.192a2280.svg";